class Vehicle {
  constructor(
    id,
    active,
    clientID,
    model,
    plate,
    createdDate,
    year,
    equipments,
    description,
    isolated,
  ) {
    this.id = id
    this.active = active
    this.clientID = clientID
    this.model = model
    this.plate = plate
    this.createdDate = createdDate
    this.year = year
    this.equipments = equipments
    this.description = description
    this.isolated = isolated
  }

}

export const vehicleDefault = () => {
  const vehicle = {
    id: 0,
    active: true,
    clientID: 0,
    model: "",
    plate: "",
    createdDate: "",
    year: "",
    equipments: [],
    description: null,
    isolated: false
  }
  return vehicle
}

export default Vehicle
